(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode('._tfpa-head_pb95d_1{height:100%;display:flex;align-items:center;justify-content:center;min-width:inherit}._tfpa-parent_pb95d_8{position:relative;top:0;left:0;height:100%;width:100%}._tfpa-image1_pb95d_15{position:relative;top:0;left:0;max-width:100%;max-height:100%}._tfpa-image1-drivewear_pb95d_26{position:relative;top:2px;left:0;max-width:100%;max-height:100%}._tfpa-image2_pb95d_37{position:absolute;top:0;left:0;max-width:100%;max-height:100%;z-index:3}._tfpa-image2-drivewear_pb95d_48{position:absolute;top:0;left:0;max-width:100%;max-height:100%;z-index:2}._tfpa-drivewear_pb95d_60{position:absolute;top:0;left:0;width:100%;height:100%;animation:_tfpa-pulse_pb95d_1 6s infinite alternate}._tfpa-wbg_pb95d_69{position:absolute;top:0;left:0;width:inherit;height:inherit;z-index:1}._tfpa-transitions-logo_pb95d_78{position:absolute;top:0;right:0}._tfpa-logo_pb95d_84{position:absolute;top:0;width:inherit}@keyframes _tfpa-pulse_pb95d_1{0%{background-color:#767c38}16.67%{background-color:#684.4}33.34%{background-color:#332f28}66.68%{background-color:#684.4}to{background-color:#767c38}}._tfpa-none_pb95d_109{display:none}@keyframes _tfpa-signatureAnimation_pb95d_1{0%{opacity:0}10%{opacity:0}50%{opacity:.8}90%{opacity:0}to{opacity:0}}@-o-keyframes _tfpa-signatureAnimation_pb95d_1{0%{opacity:0}10%{opacity:0}50%{opacity:.8}90%{opacity:0}to{opacity:0}}@-moz-keyframes _tfpa-signatureAnimation_pb95d_1{0%{opacity:0}10%{opacity:0}50%{opacity:.8}90%{opacity:0}to{opacity:0}}@-webkit-keyframes _tfpa-signatureAnimation_pb95d_1{0%{opacity:0}10%{opacity:0}50%{opacity:.8}90%{opacity:0}to{opacity:0}}._tfpa-signature_pb95d_145{width:inherit;-webkit-animation:_tfpa-signatureAnimation_pb95d_1 5s infinite;-moz-animation:_tfpa-signatureAnimation_pb95d_1 5s infinite;-o-animation:_tfpa-signatureAnimation_pb95d_1 5s infinite;animation:_tfpa-signatureAnimation_pb95d_1 5s infinite}@keyframes _tfpa-xtractiveAnimation_pb95d_1{0%{opacity:.4}14%{opacity:.4}28%{opacity:1}86%{opacity:.4}to{opacity:.4}}@-o-keyframes _tfpa-xtractiveAnimation_pb95d_1{0%{opacity:.4}14%{opacity:.4}28%{opacity:1}86%{opacity:.4}to{opacity:.4}}@-moz-keyframes _tfpa-xtractiveAnimation_pb95d_1{0%{opacity:.4}14%{opacity:.4}28%{opacity:1}86%{opacity:.4}to{opacity:.4}}@-webkit-keyframes _tfpa-xtractiveAnimation_pb95d_1{0%{opacity:.4}14%{opacity:.4}28%{opacity:1}86%{opacity:.4}to{opacity:.4}}._tfpa-xtractive_pb95d_185{width:inherit;-webkit-animation:_tfpa-xtractiveAnimation_pb95d_1 7s infinite;-moz-animation:_tfpa-xtractiveAnimation_pb95d_1 7s infinite;-o-animation:_tfpa-xtractiveAnimation_pb95d_1 7s infinite;animation:_tfpa-xtractiveAnimation_pb95d_1 7s infinite}._tfpa-loader_pb95d_193{display:inline-block;width:80px;height:80px}._tfpa-loader_pb95d_193:after{content:" ";display:block;width:64px;height:64px;margin:8px;border-radius:50%;border:6px solid #6986B0;border-color:#6986B0 transparent #6986B0 transparent;animation:_tfpa-loader_pb95d_193 1.2s linear infinite}@keyframes _tfpa-loader_pb95d_193{0%{transform:rotate(0)}to{transform:rotate(360deg)}}')),document.head.appendChild(t)}}catch(i){console.error("vite-plugin-css-injected-by-js",i)}})();
import Ee, { useRef as _t, useDebugValue as er, createElement as vn, useContext as gn, useState as tr, useEffect as mt } from "react";
var Et = { exports: {} }, Fe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rr;
function yn() {
  if (rr)
    return Fe;
  rr = 1;
  var e = Ee, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(f, u, d) {
    var p, y = {}, b = null, E = null;
    d !== void 0 && (b = "" + d), u.key !== void 0 && (b = "" + u.key), u.ref !== void 0 && (E = u.ref);
    for (p in u)
      n.call(u, p) && !a.hasOwnProperty(p) && (y[p] = u[p]);
    if (f && f.defaultProps)
      for (p in u = f.defaultProps, u)
        y[p] === void 0 && (y[p] = u[p]);
    return { $$typeof: t, type: f, key: b, ref: E, props: y, _owner: i.current };
  }
  return Fe.Fragment = r, Fe.jsx = c, Fe.jsxs = c, Fe;
}
var ze = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nr;
function bn() {
  return nr || (nr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ee, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), O = Symbol.iterator, A = "@@iterator";
    function N(o) {
      if (o === null || typeof o != "object")
        return null;
      var s = O && o[O] || o[A];
      return typeof s == "function" ? s : null;
    }
    var h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(o) {
      {
        for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          l[m - 1] = arguments[m];
        S("error", o, l);
      }
    }
    function S(o, s, l) {
      {
        var m = h.ReactDebugCurrentFrame, C = m.getStackAddendum();
        C !== "" && (s += "%s", l = l.concat([C]));
        var I = l.map(function(k) {
          return String(k);
        });
        I.unshift("Warning: " + s), Function.prototype.apply.call(console[o], console, I);
      }
    }
    var P = !1, x = !1, _ = !1, g = !1, ee = !1, te;
    te = Symbol.for("react.module.reference");
    function Le(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === a || ee || o === i || o === d || o === p || g || o === E || P || x || _ || typeof o == "object" && o !== null && (o.$$typeof === b || o.$$typeof === y || o.$$typeof === c || o.$$typeof === f || o.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === te || o.getModuleId !== void 0));
    }
    function ke(o, s, l) {
      var m = o.displayName;
      if (m)
        return m;
      var C = s.displayName || s.name || "";
      return C !== "" ? l + "(" + C + ")" : l;
    }
    function de(o) {
      return o.displayName || "Context";
    }
    function B(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case d:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case f:
            var s = o;
            return de(s) + ".Consumer";
          case c:
            var l = o;
            return de(l._context) + ".Provider";
          case u:
            return ke(o, o.render, "ForwardRef");
          case y:
            var m = o.displayName || null;
            return m !== null ? m : B(o.type) || "Memo";
          case b: {
            var C = o, I = C._payload, k = C._init;
            try {
              return B(k(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ae = 0, D, F, U, W, X, G, pe;
    function he() {
    }
    he.__reactDisabledLog = !0;
    function se() {
      {
        if (ae === 0) {
          D = console.log, F = console.info, U = console.warn, W = console.error, X = console.group, G = console.groupCollapsed, pe = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: he,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        ae++;
      }
    }
    function ce() {
      {
        if (ae--, ae === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, o, {
              value: D
            }),
            info: K({}, o, {
              value: F
            }),
            warn: K({}, o, {
              value: U
            }),
            error: K({}, o, {
              value: W
            }),
            group: K({}, o, {
              value: X
            }),
            groupCollapsed: K({}, o, {
              value: G
            }),
            groupEnd: K({}, o, {
              value: pe
            })
          });
        }
        ae < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var me = h.ReactCurrentDispatcher, ne;
    function J(o, s, l) {
      {
        if (ne === void 0)
          try {
            throw Error();
          } catch (C) {
            var m = C.stack.trim().match(/\n( *(at )?)/);
            ne = m && m[1] || "";
          }
        return `
` + ne + o;
      }
    }
    var ge = !1, ue;
    {
      var oe = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new oe();
    }
    function zt(o, s) {
      if (!o || ge)
        return "";
      {
        var l = ue.get(o);
        if (l !== void 0)
          return l;
      }
      var m;
      ge = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var I;
      I = me.current, me.current = null, se();
      try {
        if (s) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (le) {
              m = le;
            }
            Reflect.construct(o, [], k);
          } else {
            try {
              k.call();
            } catch (le) {
              m = le;
            }
            o.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (le) {
            m = le;
          }
          o();
        }
      } catch (le) {
        if (le && m && typeof le.stack == "string") {
          for (var R = le.stack.split(`
`), V = m.stack.split(`
`), M = R.length - 1, L = V.length - 1; M >= 1 && L >= 0 && R[M] !== V[L]; )
            L--;
          for (; M >= 1 && L >= 0; M--, L--)
            if (R[M] !== V[L]) {
              if (M !== 1 || L !== 1)
                do
                  if (M--, L--, L < 0 || R[M] !== V[L]) {
                    var Z = `
` + R[M].replace(" at new ", " at ");
                    return o.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", o.displayName)), typeof o == "function" && ue.set(o, Z), Z;
                  }
                while (M >= 1 && L >= 0);
              break;
            }
        }
      } finally {
        ge = !1, me.current = I, ce(), Error.prepareStackTrace = C;
      }
      var Oe = o ? o.displayName || o.name : "", Qt = Oe ? J(Oe) : "";
      return typeof o == "function" && ue.set(o, Qt), Qt;
    }
    function Ur(o, s, l) {
      return zt(o, !1);
    }
    function qr(o) {
      var s = o.prototype;
      return !!(s && s.isReactComponent);
    }
    function Ve(o, s, l) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return zt(o, qr(o));
      if (typeof o == "string")
        return J(o);
      switch (o) {
        case d:
          return J("Suspense");
        case p:
          return J("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case u:
            return Ur(o.render);
          case y:
            return Ve(o.type, s, l);
          case b: {
            var m = o, C = m._payload, I = m._init;
            try {
              return Ve(I(C), s, l);
            } catch {
            }
          }
        }
      return "";
    }
    var We = Object.prototype.hasOwnProperty, Gt = {}, Bt = h.ReactDebugCurrentFrame;
    function Ye(o) {
      if (o) {
        var s = o._owner, l = Ve(o.type, o._source, s ? s.type : null);
        Bt.setExtraStackFrame(l);
      } else
        Bt.setExtraStackFrame(null);
    }
    function Kr(o, s, l, m, C) {
      {
        var I = Function.call.bind(We);
        for (var k in o)
          if (I(o, k)) {
            var R = void 0;
            try {
              if (typeof o[k] != "function") {
                var V = Error((m || "React class") + ": " + l + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              R = o[k](s, k, m, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              R = M;
            }
            R && !(R instanceof Error) && (Ye(C), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", l, k, typeof R), Ye(null)), R instanceof Error && !(R.message in Gt) && (Gt[R.message] = !0, Ye(C), v("Failed %s type: %s", l, R.message), Ye(null));
          }
      }
    }
    var Xr = Array.isArray;
    function lt(o) {
      return Xr(o);
    }
    function Jr(o) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, l = s && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return l;
      }
    }
    function Zr(o) {
      try {
        return Vt(o), !1;
      } catch {
        return !0;
      }
    }
    function Vt(o) {
      return "" + o;
    }
    function Wt(o) {
      if (Zr(o))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Jr(o)), Vt(o);
    }
    var $e = h.ReactCurrentOwner, Qr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Yt, Ht, ft;
    ft = {};
    function en(o) {
      if (We.call(o, "ref")) {
        var s = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function tn(o) {
      if (We.call(o, "key")) {
        var s = Object.getOwnPropertyDescriptor(o, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function rn(o, s) {
      if (typeof o.ref == "string" && $e.current && s && $e.current.stateNode !== s) {
        var l = B($e.current.type);
        ft[l] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B($e.current.type), o.ref), ft[l] = !0);
      }
    }
    function nn(o, s) {
      {
        var l = function() {
          Yt || (Yt = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        l.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: l,
          configurable: !0
        });
      }
    }
    function on(o, s) {
      {
        var l = function() {
          Ht || (Ht = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        l.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: l,
          configurable: !0
        });
      }
    }
    var an = function(o, s, l, m, C, I, k) {
      var R = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: s,
        ref: l,
        props: k,
        // Record the component responsible for creating this element.
        _owner: I
      };
      return R._store = {}, Object.defineProperty(R._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(R, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(R.props), Object.freeze(R)), R;
    };
    function sn(o, s, l, m, C) {
      {
        var I, k = {}, R = null, V = null;
        l !== void 0 && (Wt(l), R = "" + l), tn(s) && (Wt(s.key), R = "" + s.key), en(s) && (V = s.ref, rn(s, C));
        for (I in s)
          We.call(s, I) && !Qr.hasOwnProperty(I) && (k[I] = s[I]);
        if (o && o.defaultProps) {
          var M = o.defaultProps;
          for (I in M)
            k[I] === void 0 && (k[I] = M[I]);
        }
        if (R || V) {
          var L = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          R && nn(k, L), V && on(k, L);
        }
        return an(o, R, V, C, m, $e.current, k);
      }
    }
    var dt = h.ReactCurrentOwner, Ut = h.ReactDebugCurrentFrame;
    function xe(o) {
      if (o) {
        var s = o._owner, l = Ve(o.type, o._source, s ? s.type : null);
        Ut.setExtraStackFrame(l);
      } else
        Ut.setExtraStackFrame(null);
    }
    var pt;
    pt = !1;
    function ht(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function qt() {
      {
        if (dt.current) {
          var o = B(dt.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function cn(o) {
      {
        if (o !== void 0) {
          var s = o.fileName.replace(/^.*[\\\/]/, ""), l = o.lineNumber;
          return `

Check your code at ` + s + ":" + l + ".";
        }
        return "";
      }
    }
    var Kt = {};
    function un(o) {
      {
        var s = qt();
        if (!s) {
          var l = typeof o == "string" ? o : o.displayName || o.name;
          l && (s = `

Check the top-level render call using <` + l + ">.");
        }
        return s;
      }
    }
    function Xt(o, s) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var l = un(s);
        if (Kt[l])
          return;
        Kt[l] = !0;
        var m = "";
        o && o._owner && o._owner !== dt.current && (m = " It was passed a child from " + B(o._owner.type) + "."), xe(o), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, m), xe(null);
      }
    }
    function Jt(o, s) {
      {
        if (typeof o != "object")
          return;
        if (lt(o))
          for (var l = 0; l < o.length; l++) {
            var m = o[l];
            ht(m) && Xt(m, s);
          }
        else if (ht(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var C = N(o);
          if (typeof C == "function" && C !== o.entries)
            for (var I = C.call(o), k; !(k = I.next()).done; )
              ht(k.value) && Xt(k.value, s);
        }
      }
    }
    function ln(o) {
      {
        var s = o.type;
        if (s == null || typeof s == "string")
          return;
        var l;
        if (typeof s == "function")
          l = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          l = s.propTypes;
        else
          return;
        if (l) {
          var m = B(s);
          Kr(l, o.props, "prop", m, o);
        } else if (s.PropTypes !== void 0 && !pt) {
          pt = !0;
          var C = B(s);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function fn(o) {
      {
        for (var s = Object.keys(o.props), l = 0; l < s.length; l++) {
          var m = s[l];
          if (m !== "children" && m !== "key") {
            xe(o), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), xe(null);
            break;
          }
        }
        o.ref !== null && (xe(o), v("Invalid attribute `ref` supplied to `React.Fragment`."), xe(null));
      }
    }
    function Zt(o, s, l, m, C, I) {
      {
        var k = Le(o);
        if (!k) {
          var R = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = cn(C);
          V ? R += V : R += qt();
          var M;
          o === null ? M = "null" : lt(o) ? M = "array" : o !== void 0 && o.$$typeof === t ? (M = "<" + (B(o.type) || "Unknown") + " />", R = " Did you accidentally export a JSX literal instead of a component?") : M = typeof o, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, R);
        }
        var L = sn(o, s, l, C, I);
        if (L == null)
          return L;
        if (k) {
          var Z = s.children;
          if (Z !== void 0)
            if (m)
              if (lt(Z)) {
                for (var Oe = 0; Oe < Z.length; Oe++)
                  Jt(Z[Oe], o);
                Object.freeze && Object.freeze(Z);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Jt(Z, o);
        }
        return o === n ? fn(L) : ln(L), L;
      }
    }
    function dn(o, s, l) {
      return Zt(o, s, l, !0);
    }
    function pn(o, s, l) {
      return Zt(o, s, l, !1);
    }
    var hn = pn, mn = dn;
    ze.Fragment = n, ze.jsx = hn, ze.jsxs = mn;
  }()), ze;
}
process.env.NODE_ENV === "production" ? Et.exports = yn() : Et.exports = bn();
var q = Et.exports, wr = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(i, a) {
      return i[0] === r ? (n = a, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var n = e(this.__entries__, r), i = this.__entries__[n];
        return i && i[1];
      }, t.prototype.set = function(r, n) {
        var i = e(this.__entries__, r);
        ~i ? this.__entries__[i][1] = n : this.__entries__.push([r, n]);
      }, t.prototype.delete = function(r) {
        var n = this.__entries__, i = e(n, r);
        ~i && n.splice(i, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var i = 0, a = this.__entries__; i < a.length; i++) {
          var c = a[i];
          r.call(n, c[1], c[0]);
        }
      }, t;
    }()
  );
}(), St = typeof window < "u" && typeof document < "u" && window.document === document, et = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), wn = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(et) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), _n = 2;
function En(e, t) {
  var r = !1, n = !1, i = 0;
  function a() {
    r && (r = !1, e()), n && f();
  }
  function c() {
    wn(a);
  }
  function f() {
    var u = Date.now();
    if (r) {
      if (u - i < _n)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(c, t);
    i = u;
  }
  return f;
}
var Sn = 20, Rn = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], kn = typeof MutationObserver < "u", xn = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = En(this.refresh.bind(this), Sn);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, n = r.indexOf(t);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !St || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), kn ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !St || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, n = r === void 0 ? "" : r, i = Rn.some(function(a) {
        return !!~n.indexOf(a);
      });
      i && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), _r = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var i = n[r];
    Object.defineProperty(e, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Ae = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || et;
}, Er = ot(0, 0, 0, 0);
function tt(e) {
  return parseFloat(e) || 0;
}
function or(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, i) {
    var a = e["border-" + i + "-width"];
    return n + tt(a);
  }, 0);
}
function On(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, i = t; n < i.length; n++) {
    var a = i[n], c = e["padding-" + a];
    r[a] = tt(c);
  }
  return r;
}
function Cn(e) {
  var t = e.getBBox();
  return ot(0, 0, t.width, t.height);
}
function An(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return Er;
  var n = Ae(e).getComputedStyle(e), i = On(n), a = i.left + i.right, c = i.top + i.bottom, f = tt(n.width), u = tt(n.height);
  if (n.boxSizing === "border-box" && (Math.round(f + a) !== t && (f -= or(n, "left", "right") + a), Math.round(u + c) !== r && (u -= or(n, "top", "bottom") + c)), !Pn(e)) {
    var d = Math.round(f + a) - t, p = Math.round(u + c) - r;
    Math.abs(d) !== 1 && (f -= d), Math.abs(p) !== 1 && (u -= p);
  }
  return ot(i.left, i.top, f, u);
}
var Tn = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Ae(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Ae(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function Pn(e) {
  return e === Ae(e).document.documentElement;
}
function Nn(e) {
  return St ? Tn(e) ? Cn(e) : An(e) : Er;
}
function In(e) {
  var t = e.x, r = e.y, n = e.width, i = e.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, c = Object.create(a.prototype);
  return _r(c, {
    x: t,
    y: r,
    width: n,
    height: i,
    top: r,
    right: t + n,
    bottom: i + r,
    left: t
  }), c;
}
function ot(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var Dn = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = ot(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Nn(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), jn = (
  /** @class */
  function() {
    function e(t, r) {
      var n = In(r);
      _r(this, { target: t, contentRect: n });
    }
    return e;
  }()
), Mn = (
  /** @class */
  function() {
    function e(t, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new wr(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Ae(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new Dn(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Ae(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new jn(n.target, n.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Sr = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new wr(), Rr = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = xn.getInstance(), n = new Mn(t, r, this);
      Sr.set(this, n);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  Rr.prototype[e] = function() {
    var t;
    return (t = Sr.get(this))[e].apply(t, arguments);
  };
});
var Ln = function() {
  return typeof et.ResizeObserver < "u" ? et.ResizeObserver : Rr;
}(), H = function() {
  return H = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, H.apply(this, arguments);
};
function Se(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, a; n < i; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function $n(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var Fn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, zn = /* @__PURE__ */ $n(
  function(e) {
    return Fn.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), j = "-ms-", Be = "-moz-", T = "-webkit-", kr = "comm", it = "rule", Dt = "decl", Gn = "@import", xr = "@keyframes", Bn = "@layer", Vn = Math.abs, jt = String.fromCharCode, Rt = Object.assign;
function Wn(e, t) {
  return z(e, 0) ^ 45 ? (((t << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3) : 0;
}
function Or(e) {
  return e.trim();
}
function fe(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function w(e, t, r) {
  return e.replace(t, r);
}
function Ke(e, t) {
  return e.indexOf(t);
}
function z(e, t) {
  return e.charCodeAt(t) | 0;
}
function Te(e, t, r) {
  return e.slice(t, r);
}
function ie(e) {
  return e.length;
}
function Cr(e) {
  return e.length;
}
function Ge(e, t) {
  return t.push(e), e;
}
function Yn(e, t) {
  return e.map(t).join("");
}
function ir(e, t) {
  return e.filter(function(r) {
    return !fe(r, t);
  });
}
var at = 1, Pe = 1, Ar = 0, Q = 0, $ = 0, je = "";
function st(e, t, r, n, i, a, c, f) {
  return { value: e, root: t, parent: r, type: n, props: i, children: a, line: at, column: Pe, length: c, return: "", siblings: f };
}
function ve(e, t) {
  return Rt(st("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function Ce(e) {
  for (; e.root; )
    e = ve(e.root, { children: [e] });
  Ge(e, e.siblings);
}
function Hn() {
  return $;
}
function Un() {
  return $ = Q > 0 ? z(je, --Q) : 0, Pe--, $ === 10 && (Pe = 1, at--), $;
}
function re() {
  return $ = Q < Ar ? z(je, Q++) : 0, Pe++, $ === 10 && (Pe = 1, at++), $;
}
function we() {
  return z(je, Q);
}
function Xe() {
  return Q;
}
function ct(e, t) {
  return Te(je, e, t);
}
function kt(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function qn(e) {
  return at = Pe = 1, Ar = ie(je = e), Q = 0, [];
}
function Kn(e) {
  return je = "", e;
}
function vt(e) {
  return Or(ct(Q - 1, xt(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Xn(e) {
  for (; ($ = we()) && $ < 33; )
    re();
  return kt(e) > 2 || kt($) > 3 ? "" : " ";
}
function Jn(e, t) {
  for (; --t && re() && !($ < 48 || $ > 102 || $ > 57 && $ < 65 || $ > 70 && $ < 97); )
    ;
  return ct(e, Xe() + (t < 6 && we() == 32 && re() == 32));
}
function xt(e) {
  for (; re(); )
    switch ($) {
      case e:
        return Q;
      case 34:
      case 39:
        e !== 34 && e !== 39 && xt($);
        break;
      case 40:
        e === 41 && xt(e);
        break;
      case 92:
        re();
        break;
    }
  return Q;
}
function Zn(e, t) {
  for (; re() && e + $ !== 47 + 10; )
    if (e + $ === 42 + 42 && we() === 47)
      break;
  return "/*" + ct(t, Q - 1) + "*" + jt(e === 47 ? e : re());
}
function Qn(e) {
  for (; !kt(we()); )
    re();
  return ct(e, Q);
}
function eo(e) {
  return Kn(Je("", null, null, null, [""], e = qn(e), 0, [0], e));
}
function Je(e, t, r, n, i, a, c, f, u) {
  for (var d = 0, p = 0, y = c, b = 0, E = 0, O = 0, A = 1, N = 1, h = 1, v = 0, S = "", P = i, x = a, _ = n, g = S; N; )
    switch (O = v, v = re()) {
      case 40:
        if (O != 108 && z(g, y - 1) == 58) {
          Ke(g += w(vt(v), "&", "&\f"), "&\f") != -1 && (h = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        g += vt(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        g += Xn(O);
        break;
      case 92:
        g += Jn(Xe() - 1, 7);
        continue;
      case 47:
        switch (we()) {
          case 42:
          case 47:
            Ge(to(Zn(re(), Xe()), t, r, u), u);
            break;
          default:
            g += "/";
        }
        break;
      case 123 * A:
        f[d++] = ie(g) * h;
      case 125 * A:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            N = 0;
          case 59 + p:
            h == -1 && (g = w(g, /\f/g, "")), E > 0 && ie(g) - y && Ge(E > 32 ? sr(g + ";", n, r, y - 1, u) : sr(w(g, " ", "") + ";", n, r, y - 2, u), u);
            break;
          case 59:
            g += ";";
          default:
            if (Ge(_ = ar(g, t, r, d, p, i, f, S, P = [], x = [], y, a), a), v === 123)
              if (p === 0)
                Je(g, t, _, _, P, a, y, f, x);
              else
                switch (b === 99 && z(g, 3) === 110 ? 100 : b) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Je(e, _, _, n && Ge(ar(e, _, _, 0, 0, i, f, S, i, P = [], y, x), x), i, x, y, f, n ? P : x);
                    break;
                  default:
                    Je(g, _, _, _, [""], x, 0, f, x);
                }
        }
        d = p = E = 0, A = h = 1, S = g = "", y = c;
        break;
      case 58:
        y = 1 + ie(g), E = O;
      default:
        if (A < 1) {
          if (v == 123)
            --A;
          else if (v == 125 && A++ == 0 && Un() == 125)
            continue;
        }
        switch (g += jt(v), v * A) {
          case 38:
            h = p > 0 ? 1 : (g += "\f", -1);
            break;
          case 44:
            f[d++] = (ie(g) - 1) * h, h = 1;
            break;
          case 64:
            we() === 45 && (g += vt(re())), b = we(), p = y = ie(S = g += Qn(Xe())), v++;
            break;
          case 45:
            O === 45 && ie(g) == 2 && (A = 0);
        }
    }
  return a;
}
function ar(e, t, r, n, i, a, c, f, u, d, p, y) {
  for (var b = i - 1, E = i === 0 ? a : [""], O = Cr(E), A = 0, N = 0, h = 0; A < n; ++A)
    for (var v = 0, S = Te(e, b + 1, b = Vn(N = c[A])), P = e; v < O; ++v)
      (P = Or(N > 0 ? E[v] + " " + S : w(S, /&\f/g, E[v]))) && (u[h++] = P);
  return st(e, t, r, i === 0 ? it : f, u, d, p, y);
}
function to(e, t, r, n) {
  return st(e, t, r, kr, jt(Hn()), Te(e, 2, -2), 0, n);
}
function sr(e, t, r, n, i) {
  return st(e, t, r, Dt, Te(e, 0, n), Te(e, n + 1, -1), n, i);
}
function Tr(e, t, r) {
  switch (Wn(e, t)) {
    case 5103:
      return T + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return T + e + e;
    case 4789:
      return Be + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return T + e + Be + e + j + e + e;
    case 5936:
      switch (z(e, t + 11)) {
        case 114:
          return T + e + j + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return T + e + j + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return T + e + j + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return T + e + j + e + e;
    case 6165:
      return T + e + j + "flex-" + e + e;
    case 5187:
      return T + e + w(e, /(\w+).+(:[^]+)/, T + "box-$1$2" + j + "flex-$1$2") + e;
    case 5443:
      return T + e + j + "flex-item-" + w(e, /flex-|-self/g, "") + (fe(e, /flex-|baseline/) ? "" : j + "grid-row-" + w(e, /flex-|-self/g, "")) + e;
    case 4675:
      return T + e + j + "flex-line-pack" + w(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return T + e + j + w(e, "shrink", "negative") + e;
    case 5292:
      return T + e + j + w(e, "basis", "preferred-size") + e;
    case 6060:
      return T + "box-" + w(e, "-grow", "") + T + e + j + w(e, "grow", "positive") + e;
    case 4554:
      return T + w(e, /([^-])(transform)/g, "$1" + T + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, T + "$1"), /(image-set)/, T + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, T + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, T + "box-pack:$3" + j + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + T + e + e;
    case 4200:
      if (!fe(e, /flex-|baseline/))
        return j + "grid-column-align" + Te(e, t) + e;
      break;
    case 2592:
    case 3360:
      return j + w(e, "template-", "") + e;
    case 4384:
    case 3616:
      return r && r.some(function(n, i) {
        return t = i, fe(n.props, /grid-\w+-end/);
      }) ? ~Ke(e + (r = r[t].value), "span") ? e : j + w(e, "-start", "") + e + j + "grid-row-span:" + (~Ke(r, "span") ? fe(r, /\d+/) : +fe(r, /\d+/) - +fe(e, /\d+/)) + ";" : j + w(e, "-start", "") + e;
    case 4896:
    case 4128:
      return r && r.some(function(n) {
        return fe(n.props, /grid-\w+-start/);
      }) ? e : j + w(w(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, T + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ie(e) - 1 - t > 6)
        switch (z(e, t + 1)) {
          case 109:
            if (z(e, t + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + T + "$2-$3$1" + Be + (z(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Ke(e, "stretch") ? Tr(w(e, "stretch", "fill-available"), t, r) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return w(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(n, i, a, c, f, u, d) {
        return j + i + ":" + a + d + (c ? j + i + "-span:" + (f ? u : +u - +a) + d : "") + e;
      });
    case 4949:
      if (z(e, t + 6) === 121)
        return w(e, ":", ":" + T) + e;
      break;
    case 6444:
      switch (z(e, z(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return w(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + T + (z(e, 14) === 45 ? "inline-" : "") + "box$3$1" + T + "$2$3$1" + j + "$2box$3") + e;
        case 100:
          return w(e, ":", ":" + j) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return w(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function rt(e, t) {
  for (var r = "", n = 0; n < e.length; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function ro(e, t, r, n) {
  switch (e.type) {
    case Bn:
      if (e.children.length)
        break;
    case Gn:
    case Dt:
      return e.return = e.return || e.value;
    case kr:
      return "";
    case xr:
      return e.return = e.value + "{" + rt(e.children, n) + "}";
    case it:
      if (!ie(e.value = e.props.join(",")))
        return "";
  }
  return ie(r = rt(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function no(e) {
  var t = Cr(e);
  return function(r, n, i, a) {
    for (var c = "", f = 0; f < t; f++)
      c += e[f](r, n, i, a) || "";
    return c;
  };
}
function oo(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function io(e, t, r, n) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Dt:
        e.return = Tr(e.value, e.length, r);
        return;
      case xr:
        return rt([ve(e, { value: w(e.value, "@", "@" + T) })], n);
      case it:
        if (e.length)
          return Yn(r = e.props, function(i) {
            switch (fe(i, n = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Ce(ve(e, { props: [w(i, /:(read-\w+)/, ":" + Be + "$1")] })), Ce(ve(e, { props: [i] })), Rt(e, { props: ir(r, n) });
                break;
              case "::placeholder":
                Ce(ve(e, { props: [w(i, /:(plac\w+)/, ":" + T + "input-$1")] })), Ce(ve(e, { props: [w(i, /:(plac\w+)/, ":" + Be + "$1")] })), Ce(ve(e, { props: [w(i, /:(plac\w+)/, j + "input-$1")] })), Ce(ve(e, { props: [i] })), Rt(e, { props: ir(r, n) });
                break;
            }
            return "";
          });
    }
}
var ao = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Re = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Mt = typeof window < "u" && "HTMLElement" in window, so = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), cr = /invalid hook call/i, He = /* @__PURE__ */ new Set(), co = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = t ? ' with the id of "'.concat(t, '"') : "", n = "The component ".concat(e).concat(r, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, i = console.error;
    try {
      var a = !0;
      console.error = function(c) {
        for (var f = [], u = 1; u < arguments.length; u++)
          f[u - 1] = arguments[u];
        cr.test(c) ? (a = !1, He.delete(n)) : i.apply(void 0, Se([c], f, !1));
      }, _t(), a && !He.has(n) && (console.warn(n), He.add(n));
    } catch (c) {
      cr.test(c.message) && He.delete(n);
    } finally {
      console.error = i;
    }
  }
}, ut = Object.freeze([]), Ne = Object.freeze({});
function uo(e, t, r) {
  return r === void 0 && (r = Ne), e.theme !== r.theme && e.theme || t || r.theme;
}
var Ot = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), lo = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fo = /(^-|-$)/g;
function ur(e) {
  return e.replace(lo, "-").replace(fo, "");
}
var po = /(a)(d)/gi, lr = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Ct(e) {
  var t, r = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0)
    r = lr(t % 52) + r;
  return (lr(t % 52) + r).replace(po, "$1-$2");
}
var gt, ye = function(e, t) {
  for (var r = t.length; r; )
    e = 33 * e ^ t.charCodeAt(--r);
  return e;
}, Pr = function(e) {
  return ye(5381, e);
};
function Nr(e) {
  return Ct(Pr(e) >>> 0);
}
function Ir(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function yt(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var Dr = typeof Symbol == "function" && Symbol.for, jr = Dr ? Symbol.for("react.memo") : 60115, ho = Dr ? Symbol.for("react.forward_ref") : 60112, mo = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, vo = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Mr = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, go = ((gt = {})[ho] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, gt[jr] = Mr, gt);
function fr(e) {
  return ("type" in (t = e) && t.type.$$typeof) === jr ? Mr : "$$typeof" in e ? go[e.$$typeof] : mo;
  var t;
}
var yo = Object.defineProperty, bo = Object.getOwnPropertyNames, dr = Object.getOwnPropertySymbols, wo = Object.getOwnPropertyDescriptor, _o = Object.getPrototypeOf, pr = Object.prototype;
function Lr(e, t, r) {
  if (typeof t != "string") {
    if (pr) {
      var n = _o(t);
      n && n !== pr && Lr(e, n, r);
    }
    var i = bo(t);
    dr && (i = i.concat(dr(t)));
    for (var a = fr(e), c = fr(t), f = 0; f < i.length; ++f) {
      var u = i[f];
      if (!(u in vo || r && r[u] || c && u in c || a && u in a)) {
        var d = wo(t, u);
        try {
          yo(e, u, d);
        } catch {
        }
      }
    }
  }
  return e;
}
function Ie(e) {
  return typeof e == "function";
}
function Lt(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function be(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function At(e, t) {
  if (e.length === 0)
    return "";
  for (var r = e[0], n = 1; n < e.length; n++)
    r += t ? t + e[n] : e[n];
  return r;
}
function De(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function Tt(e, t, r) {
  if (r === void 0 && (r = !1), !r && !De(e) && !Array.isArray(e))
    return t;
  if (Array.isArray(t))
    for (var n = 0; n < t.length; n++)
      e[n] = Tt(e[n], t[n]);
  else if (De(t))
    for (var n in t)
      e[n] = Tt(e[n], t[n]);
  return e;
}
function $t(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
var Eo = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function So() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e[0], n = [], i = 1, a = e.length; i < a; i += 1)
    n.push(e[i]);
  return n.forEach(function(c) {
    r = r.replace(/%[a-z]/, c);
  }), r;
}
function Me(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : "")) : new Error(So.apply(void 0, Se([Eo[e]], t, !1)).trim());
}
var Ro = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var r = 0, n = 0; n < t; n++)
      r += this.groupSizes[n];
    return r;
  }, e.prototype.insertRules = function(t, r) {
    if (t >= this.groupSizes.length) {
      for (var n = this.groupSizes, i = n.length, a = i; t >= a; )
        if ((a <<= 1) < 0)
          throw Me(16, "".concat(t));
      this.groupSizes = new Uint32Array(a), this.groupSizes.set(n), this.length = a;
      for (var c = i; c < a; c++)
        this.groupSizes[c] = 0;
    }
    for (var f = this.indexOfGroup(t + 1), u = (c = 0, r.length); c < u; c++)
      this.tag.insertRule(f, r[c]) && (this.groupSizes[t]++, f++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var r = this.groupSizes[t], n = this.indexOfGroup(t), i = n + r;
      this.groupSizes[t] = 0;
      for (var a = n; a < i; a++)
        this.tag.deleteRule(n);
    }
  }, e.prototype.getGroup = function(t) {
    var r = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return r;
    for (var n = this.groupSizes[t], i = this.indexOfGroup(t), a = i + n, c = i; c < a; c++)
      r += "".concat(this.tag.getRule(c)).concat(`/*!sc*/
`);
    return r;
  }, e;
}(), Ze = /* @__PURE__ */ new Map(), nt = /* @__PURE__ */ new Map(), Qe = 1, Ue = function(e) {
  if (Ze.has(e))
    return Ze.get(e);
  for (; nt.has(Qe); )
    Qe++;
  var t = Qe++;
  if (process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1073741824))
    throw Me(16, "".concat(t));
  return Ze.set(e, t), nt.set(t, e), t;
}, ko = function(e, t) {
  Qe = t + 1, Ze.set(e, t), nt.set(t, e);
}, xo = "style[".concat(Re, "][").concat("data-styled-version", '="').concat("6.1.1", '"]'), Oo = new RegExp("^".concat(Re, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Co = function(e, t, r) {
  for (var n, i = r.split(","), a = 0, c = i.length; a < c; a++)
    (n = i[a]) && e.registerName(t, n);
}, Ao = function(e, t) {
  for (var r, n = ((r = t.textContent) !== null && r !== void 0 ? r : "").split(`/*!sc*/
`), i = [], a = 0, c = n.length; a < c; a++) {
    var f = n[a].trim();
    if (f) {
      var u = f.match(Oo);
      if (u) {
        var d = 0 | parseInt(u[1], 10), p = u[2];
        d !== 0 && (ko(p, d), Co(e, p, u[3]), e.getTag().insertRules(d, i)), i.length = 0;
      } else
        i.push(f);
    }
  }
};
function To() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var $r = function(e) {
  var t = document.head, r = e || t, n = document.createElement("style"), i = function(f) {
    var u = Array.from(f.querySelectorAll("style[".concat(Re, "]")));
    return u[u.length - 1];
  }(r), a = i !== void 0 ? i.nextSibling : null;
  n.setAttribute(Re, "active"), n.setAttribute("data-styled-version", "6.1.1");
  var c = To();
  return c && n.setAttribute("nonce", c), r.insertBefore(n, a), n;
}, Po = function() {
  function e(t) {
    this.element = $r(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(r) {
      if (r.sheet)
        return r.sheet;
      for (var n = document.styleSheets, i = 0, a = n.length; i < a; i++) {
        var c = n[i];
        if (c.ownerNode === r)
          return c;
      }
      throw Me(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, r) {
    try {
      return this.sheet.insertRule(r, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var r = this.sheet.cssRules[t];
    return r && r.cssText ? r.cssText : "";
  }, e;
}(), No = function() {
  function e(t) {
    this.element = $r(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, r) {
    if (t <= this.length && t >= 0) {
      var n = document.createTextNode(r);
      return this.element.insertBefore(n, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), Io = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, r) {
    return t <= this.length && (this.rules.splice(t, 0, r), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), hr = Mt, Do = { isServer: !Mt, useCSSOMInjection: !so }, Fr = function() {
  function e(t, r, n) {
    t === void 0 && (t = Ne), r === void 0 && (r = {});
    var i = this;
    this.options = H(H({}, Do), t), this.gs = r, this.names = new Map(n), this.server = !!t.isServer, !this.server && Mt && hr && (hr = !1, function(a) {
      for (var c = document.querySelectorAll(xo), f = 0, u = c.length; f < u; f++) {
        var d = c[f];
        d && d.getAttribute(Re) !== "active" && (Ao(a, d), d.parentNode && d.parentNode.removeChild(d));
      }
    }(this)), $t(this, function() {
      return function(a) {
        for (var c = a.getTag(), f = c.length, u = "", d = function(y) {
          var b = function(h) {
            return nt.get(h);
          }(y);
          if (b === void 0)
            return "continue";
          var E = a.names.get(b), O = c.getGroup(y);
          if (E === void 0 || O.length === 0)
            return "continue";
          var A = "".concat(Re, ".g").concat(y, '[id="').concat(b, '"]'), N = "";
          E !== void 0 && E.forEach(function(h) {
            h.length > 0 && (N += "".concat(h, ","));
          }), u += "".concat(O).concat(A, '{content:"').concat(N, '"}').concat(`/*!sc*/
`);
        }, p = 0; p < f; p++)
          d(p);
        return u;
      }(i);
    });
  }
  return e.registerId = function(t) {
    return Ue(t);
  }, e.prototype.reconstructWithOptions = function(t, r) {
    return r === void 0 && (r = !0), new e(H(H({}, this.options), t), this.gs, r && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(r) {
      var n = r.useCSSOMInjection, i = r.target;
      return r.isServer ? new Io(i) : n ? new Po(i) : new No(i);
    }(this.options), new Ro(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, r) {
    return this.names.has(t) && this.names.get(t).has(r);
  }, e.prototype.registerName = function(t, r) {
    if (Ue(t), this.names.has(t))
      this.names.get(t).add(r);
    else {
      var n = /* @__PURE__ */ new Set();
      n.add(r), this.names.set(t, n);
    }
  }, e.prototype.insertRules = function(t, r, n) {
    this.registerName(t, r), this.getTag().insertRules(Ue(t), n);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(Ue(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), jo = /&/g, Mo = /^\s*\/\/.*$/gm;
function zr(e, t) {
  return e.map(function(r) {
    return r.type === "rule" && (r.value = "".concat(t, " ").concat(r.value), r.value = r.value.replaceAll(",", ",".concat(t, " ")), r.props = r.props.map(function(n) {
      return "".concat(t, " ").concat(n);
    })), Array.isArray(r.children) && r.type !== "@keyframes" && (r.children = zr(r.children, t)), r;
  });
}
function Lo(e) {
  var t, r, n, i = e === void 0 ? Ne : e, a = i.options, c = a === void 0 ? Ne : a, f = i.plugins, u = f === void 0 ? ut : f, d = function(b, E, O) {
    return O === r || O.startsWith(r) && O.endsWith(r) && O.replaceAll(r, "").length > 0 ? ".".concat(t) : b;
  }, p = u.slice();
  p.push(function(b) {
    b.type === it && b.value.includes("&") && (b.props[0] = b.props[0].replace(jo, r).replace(n, d));
  }), c.prefix && p.push(io), p.push(ro);
  var y = function(b, E, O, A) {
    E === void 0 && (E = ""), O === void 0 && (O = ""), A === void 0 && (A = "&"), t = A, r = E, n = new RegExp("\\".concat(r, "\\b"), "g");
    var N = b.replace(Mo, ""), h = eo(O || E ? "".concat(O, " ").concat(E, " { ").concat(N, " }") : N);
    c.namespace && (h = zr(h, c.namespace));
    var v = [];
    return rt(h, no(p.concat(oo(function(S) {
      return v.push(S);
    })))), v;
  };
  return y.hash = u.length ? u.reduce(function(b, E) {
    return E.name || Me(15), ye(b, E.name);
  }, 5381).toString() : "", y;
}
var $o = new Fr(), Pt = Lo(), Gr = Ee.createContext({ shouldForwardProp: void 0, styleSheet: $o, stylis: Pt });
Gr.Consumer;
Ee.createContext(void 0);
function mr() {
  return gn(Gr);
}
var Nt = function() {
  function e(t, r) {
    var n = this;
    this.inject = function(i, a) {
      a === void 0 && (a = Pt);
      var c = n.name + a.hash;
      i.hasNameForId(n.id, c) || i.insertRules(n.id, c, a(n.rules, c, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = r, $t(this, function() {
      throw Me(12, String(n.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Pt), this.name + t.hash;
  }, e;
}(), Fo = function(e) {
  return e >= "A" && e <= "Z";
};
function vr(e) {
  for (var t = "", r = 0; r < e.length; r++) {
    var n = e[r];
    if (r === 1 && n === "-" && e[0] === "-")
      return e;
    Fo(n) ? t += "-" + n.toLowerCase() : t += n;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Br = function(e) {
  return e == null || e === !1 || e === "";
}, Vr = function(e) {
  var t, r, n = [];
  for (var i in e) {
    var a = e[i];
    e.hasOwnProperty(i) && !Br(a) && (Array.isArray(a) && a.isCss || Ie(a) ? n.push("".concat(vr(i), ":"), a, ";") : De(a) ? n.push.apply(n, Se(Se(["".concat(i, " {")], Vr(a), !1), ["}"], !1)) : n.push("".concat(vr(i), ": ").concat((t = i, (r = a) == null || typeof r == "boolean" || r === "" ? "" : typeof r != "number" || r === 0 || t in ao || t.startsWith("--") ? String(r).trim() : "".concat(r, "px")), ";")));
  }
  return n;
};
function _e(e, t, r, n) {
  if (Br(e))
    return [];
  if (Lt(e))
    return [".".concat(e.styledComponentId)];
  if (Ie(e)) {
    if (!Ie(a = e) || a.prototype && a.prototype.isReactComponent || !t)
      return [e];
    var i = e(t);
    return process.env.NODE_ENV === "production" || typeof i != "object" || Array.isArray(i) || i instanceof Nt || De(i) || i === null || console.error("".concat(Ir(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), _e(i, t, r, n);
  }
  var a;
  return e instanceof Nt ? r ? (e.inject(r, n), [e.getName(n)]) : [e] : De(e) ? Vr(e) : Array.isArray(e) ? Array.prototype.concat.apply(ut, e.map(function(c) {
    return _e(c, t, r, n);
  })) : [e.toString()];
}
function zo(e) {
  for (var t = 0; t < e.length; t += 1) {
    var r = e[t];
    if (Ie(r) && !Lt(r))
      return !1;
  }
  return !0;
}
var Go = Pr("6.1.1"), Bo = function() {
  function e(t, r, n) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && zo(t), this.componentId = r, this.baseHash = ye(Go, r), this.baseStyle = n, Fr.registerId(r);
  }
  return e.prototype.generateAndInjectStyles = function(t, r, n) {
    var i = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, r, n) : "";
    if (this.isStatic && !n.hash)
      if (this.staticRulesId && r.hasNameForId(this.componentId, this.staticRulesId))
        i = be(i, this.staticRulesId);
      else {
        var a = At(_e(this.rules, t, r, n)), c = Ct(ye(this.baseHash, a) >>> 0);
        if (!r.hasNameForId(this.componentId, c)) {
          var f = n(a, ".".concat(c), void 0, this.componentId);
          r.insertRules(this.componentId, c, f);
        }
        i = be(i, c), this.staticRulesId = c;
      }
    else {
      for (var u = ye(this.baseHash, n.hash), d = "", p = 0; p < this.rules.length; p++) {
        var y = this.rules[p];
        if (typeof y == "string")
          d += y, process.env.NODE_ENV !== "production" && (u = ye(u, y));
        else if (y) {
          var b = At(_e(y, t, r, n));
          u = ye(u, b + p), d += b;
        }
      }
      if (d) {
        var E = Ct(u >>> 0);
        r.hasNameForId(this.componentId, E) || r.insertRules(this.componentId, E, n(d, ".".concat(E), void 0, this.componentId)), i = be(i, E);
      }
    }
    return i;
  }, e;
}(), Wr = Ee.createContext(void 0);
Wr.Consumer;
var bt = {}, gr = /* @__PURE__ */ new Set();
function Vo(e, t, r) {
  var n = Lt(e), i = e, a = !yt(e), c = t.attrs, f = c === void 0 ? ut : c, u = t.componentId, d = u === void 0 ? function(P, x) {
    var _ = typeof P != "string" ? "sc" : ur(P);
    bt[_] = (bt[_] || 0) + 1;
    var g = "".concat(_, "-").concat(Nr("6.1.1" + _ + bt[_]));
    return x ? "".concat(x, "-").concat(g) : g;
  }(t.displayName, t.parentComponentId) : u, p = t.displayName, y = p === void 0 ? function(P) {
    return yt(P) ? "styled.".concat(P) : "Styled(".concat(Ir(P), ")");
  }(e) : p, b = t.displayName && t.componentId ? "".concat(ur(t.displayName), "-").concat(t.componentId) : t.componentId || d, E = n && i.attrs ? i.attrs.concat(f).filter(Boolean) : f, O = t.shouldForwardProp;
  if (n && i.shouldForwardProp) {
    var A = i.shouldForwardProp;
    if (t.shouldForwardProp) {
      var N = t.shouldForwardProp;
      O = function(P, x) {
        return A(P, x) && N(P, x);
      };
    } else
      O = A;
  }
  var h = new Bo(r, b, n ? i.componentStyle : void 0);
  function v(P, x) {
    return function(_, g, ee) {
      var te = _.attrs, Le = _.componentStyle, ke = _.defaultProps, de = _.foldedComponentIds, B = _.styledComponentId, K = _.target, ae = Ee.useContext(Wr), D = mr(), F = _.shouldForwardProp || D.shouldForwardProp;
      process.env.NODE_ENV !== "production" && er(B);
      var U = function(se, ce, me) {
        for (var ne, J = H(H({}, ce), { className: void 0, theme: me }), ge = 0; ge < se.length; ge += 1) {
          var ue = Ie(ne = se[ge]) ? ne(J) : ne;
          for (var oe in ue)
            J[oe] = oe === "className" ? be(J[oe], ue[oe]) : oe === "style" ? H(H({}, J[oe]), ue[oe]) : ue[oe];
        }
        return ce.className && (J.className = be(J.className, ce.className)), J;
      }(te, g, uo(g, ae, ke) || Ne), W = U.as || K, X = {};
      for (var G in U)
        U[G] === void 0 || G[0] === "$" || G === "as" || G === "theme" || (G === "forwardedAs" ? X.as = U.forwardedAs : F && !F(G, W) || (X[G] = U[G], F || process.env.NODE_ENV !== "development" || zn(G) || gr.has(G) || !Ot.has(W) || (gr.add(G), console.warn('styled-components: it looks like an unknown prop "'.concat(G, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var pe = function(se, ce) {
        var me = mr(), ne = se.generateAndInjectStyles(ce, me.styleSheet, me.stylis);
        return process.env.NODE_ENV !== "production" && er(ne), ne;
      }(Le, U);
      process.env.NODE_ENV !== "production" && _.warnTooManyClasses && _.warnTooManyClasses(pe);
      var he = be(de, B);
      return pe && (he += " " + pe), U.className && (he += " " + U.className), X[yt(W) && !Ot.has(W) ? "class" : "className"] = he, X.ref = ee, vn(W, X);
    }(S, P, x);
  }
  v.displayName = y;
  var S = Ee.forwardRef(v);
  return S.attrs = E, S.componentStyle = h, S.displayName = y, S.shouldForwardProp = O, S.foldedComponentIds = n ? be(i.foldedComponentIds, i.styledComponentId) : "", S.styledComponentId = b, S.target = n ? i.target : e, Object.defineProperty(S, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(P) {
    this._foldedDefaultProps = n ? function(x) {
      for (var _ = [], g = 1; g < arguments.length; g++)
        _[g - 1] = arguments[g];
      for (var ee = 0, te = _; ee < te.length; ee++)
        Tt(x, te[ee], !0);
      return x;
    }({}, i.defaultProps, P) : P;
  } }), process.env.NODE_ENV !== "production" && (co(y, b), S.warnTooManyClasses = function(P, x) {
    var _ = {}, g = !1;
    return function(ee) {
      if (!g && (_[ee] = !0, Object.keys(_).length >= 200)) {
        var te = x ? ' with the id of "'.concat(x, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(P).concat(te, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), g = !0, _ = {};
      }
    };
  }(y, b)), $t(S, function() {
    return ".".concat(S.styledComponentId);
  }), a && Lr(S, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), S;
}
function yr(e, t) {
  for (var r = [e[0]], n = 0, i = t.length; n < i; n += 1)
    r.push(t[n], e[n + 1]);
  return r;
}
var br = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function Yr(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (Ie(e) || De(e)) {
    var n = e;
    return br(_e(yr(ut, Se([n], t, !0))));
  }
  var i = e;
  return t.length === 0 && i.length === 1 && typeof i[0] == "string" ? _e(i) : br(_e(yr(i, t)));
}
function It(e, t, r) {
  if (r === void 0 && (r = Ne), !t)
    throw Me(1, t);
  var n = function(i) {
    for (var a = [], c = 1; c < arguments.length; c++)
      a[c - 1] = arguments[c];
    return e(t, r, Yr.apply(void 0, Se([i], a, !1)));
  };
  return n.attrs = function(i) {
    return It(e, t, H(H({}, r), { attrs: Array.prototype.concat(r.attrs, i).filter(Boolean) }));
  }, n.withConfig = function(i) {
    return It(e, t, H(H({}, r), i));
  }, n;
}
var Hr = function(e) {
  return It(Vo, e);
}, Ft = Hr;
Ot.forEach(function(e) {
  Ft[e] = Hr(e);
});
function Wo(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var n = At(Yr.apply(void 0, Se([e], t, !1))), i = Nr(n);
  return new Nt(i, n);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var qe = "__sc-".concat(Re, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[qe] || (window[qe] = 0), window[qe] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[qe] += 1);
const Y = {
  "tfpa-head": "_tfpa-head_pb95d_1",
  "tfpa-parent": "_tfpa-parent_pb95d_8",
  "tfpa-image1": "_tfpa-image1_pb95d_15",
  "tfpa-image1-drivewear": "_tfpa-image1-drivewear_pb95d_26",
  "tfpa-image2": "_tfpa-image2_pb95d_37",
  "tfpa-image2-drivewear": "_tfpa-image2-drivewear_pb95d_48",
  "tfpa-drivewear": "_tfpa-drivewear_pb95d_60",
  "tfpa-pulse": "_tfpa-pulse_pb95d_1",
  "tfpa-wbg": "_tfpa-wbg_pb95d_69",
  "tfpa-transitions-logo": "_tfpa-transitions-logo_pb95d_78",
  "tfpa-logo": "_tfpa-logo_pb95d_84",
  "tfpa-none": "_tfpa-none_pb95d_109",
  "tfpa-signature": "_tfpa-signature_pb95d_145",
  "tfpa-signatureAnimation": "_tfpa-signatureAnimation_pb95d_1",
  "tfpa-xtractive": "_tfpa-xtractive_pb95d_185",
  "tfpa-xtractiveAnimation": "_tfpa-xtractiveAnimation_pb95d_1",
  "tfpa-loader": "_tfpa-loader_pb95d_193"
}, wt = {
  "aviator-phantos": {
    neutral: [
      "Grey",
      "Graphite-Green"
    ],
    warm: [
      "Amber",
      "Brown",
      "Amethyst"
    ],
    cool: [
      "Grey"
    ],
    tortoise: [
      "Brown",
      "Amber"
    ]
  },
  "cateye-butterfly": {
    neutral: [
      "Grey",
      "Sapphire",
      "Emerald"
    ],
    warm: [
      "Brown",
      "Amethyst",
      "Amber"
    ],
    cool: [
      "Sapphire",
      "Amethyst"
    ],
    tortoise: [
      "Brown",
      "Grey",
      "Amber"
    ]
  },
  "rectangular-angular": {
    neutral: [
      "Graphite-Green",
      "Grey",
      "Sapphire"
    ],
    warm: [
      "Amber",
      "Brown",
      "Graphite-Green",
      "Amethyst",
      "Sapphire",
      "Emerald"
    ],
    cool: [
      "Emerald",
      "Graphite-Green",
      "Sapphire",
      "Amethyst"
    ],
    tortoise: [
      "Brown",
      "Sapphire",
      "Amber"
    ]
  },
  "round-oval": {
    neutral: [
      "Amethyst",
      "Grey",
      "Amber"
    ],
    warm: [
      "Amber",
      "Brown",
      "Amethyst"
    ],
    cool: [
      "Emerald",
      "Graphite-Green",
      "Sapphire",
      "Amethyst"
    ],
    tortoise: [
      "Brown",
      "Amber"
    ]
  }
}, Yo = (e) => {
  let t = ["frameSrc", "generateMask", "transitionsType", "integrator", "upc", "containerId"];
  for (let r = 0; r < t.length; r++)
    if (!e[t[r]])
      throw new Error(`Missing required prop: ${t[r]}`);
  return !0;
}, Ho = (e) => /^#([0-9A-F]{3}){1,2}$/i.test(e), Uo = (e) => (e = e.split("?")[0], /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(e)), qo = Wo`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`, Ko = Ft.div`
  display: inline-block;
  width: 80px;
  height: 80px;
`, Xo = Ft.div`
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid ${(e) => e.color};
  border-color: ${(e) => e.color} transparent ${(e) => e.color}
    transparent;
  animation: ${qo} 1.2s linear infinite;
`, Zo = ({ frameSrc: e, name: t, lensColor: r, generateMask: n, random: i, integrator: a, modelName: c, modelCode: f, brand: u, upc: d, showLoading: p, showLogo: y, containerId: b, isSunframe: E, onSuccess: O, onError: A, ...N }) => {
  const [h, v] = tr({
    maskLink: "",
    frameShape: "",
    frameColor: "",
    frameAngle: "",
    isLoading: !0,
    isFailed: !1,
    maskColorLinks: {},
    selectedColor: "",
    frameSrc: "",
    upc: "",
    integrator: "",
    lensRemovalMask: "",
    is_sunglass: !1
  }), [S, P] = tr({
    height: 0,
    width: 0
  }), x = _t(null), _ = _t(!0), g = p === "1", ee = y === "1", te = Ho(N.spinnerColor) ? N.spinnerColor : "#6986B0", Le = "https://tfpa-prd-app-wus-001.azurewebsites.net/v2.3.0/process-image", ke = () => {
    const D = new FormData();
    return D.append("frame", e), D.append("color", r || "Grey"), D.append("model_name", c), D.append("model_code", f), D.append("integrator", a), D.append("brand", u), D.append("upc", d), D.append("original_frame_color", N.originalFrameColor), D.append("original_frame_shape", N.originalFrameShape), D;
  }, de = (D) => {
    fetch(Le, {
      method: "POST",
      body: D
    }).then((F) => F.json()).then((F) => {
      const {
        status: U,
        links: W,
        shape: X,
        color_prediction: G,
        angle_prediction: pe,
        // lens_removed_mask: lens_removal_mask,
        is_sunglasses: he
      } = F;
      if (U !== 200)
        throw new Error(F.message || "Something went wrong.");
      O && typeof O == "function" && O();
      const se = wt[X] && wt[X][r] || wt["aviator-phantos"].neutral, ce = W[se[Math.floor(Math.random() * se.length)]] || W.Grey;
      v({
        ...h,
        maskLink: r ? W[r] : ce,
        frameShape: X,
        frameColor: G,
        frameAngle: pe,
        isLoading: !1,
        isFailed: !1,
        maskColorLinks: W,
        selectedColor: r,
        frameSrc: e,
        upc: d,
        integrator: a,
        lensRemovalMask: W.white,
        is_sunglass: he
      });
    }).catch((F) => {
      v({
        ...h,
        isLoading: !1,
        isFailed: !0,
        frameSrc: e,
        upc: d,
        integrator: a
      }), A && typeof A == "function" && A(), console.error(F);
    });
  }, B = () => {
    P({
      height: x && x.current ? x.current.clientHeight : 0,
      width: x && x.current ? x.current.clientWidth : 0
    });
  }, K = () => {
    A && typeof A == "function" && (A(), v({ ...h, isLoading: !1, isFailed: !0 }), document.getElementById("fade").style.display = "none", console.error("Mask image failed to load."));
  }, ae = () => {
    B();
  };
  return mt(() => {
    const D = document.getElementById(b), F = new Ln(ae);
    return F.observe(D), () => {
      F.unobserve(D), F.disconnect();
    };
  }, []), mt(() => {
    if (Yo({
      frameSrc: e,
      lensColor: r,
      generateMask: n,
      integrator: a,
      upc: d,
      containerId: b,
      ...N
    })) {
      const D = ke();
      i && Math.random() > 0.75 && de(D), n && !i && de(D);
    }
  }, []), mt(() => {
    if (_.current)
      _.current = !1;
    else if (h.frameSrc === e && h.upc === d && h.integrator === a && h.maskColorLinks[r])
      v({
        ...h,
        selectedColor: r,
        maskLink: h.maskColorLinks[r]
      });
    else {
      const D = ke();
      v({
        ...h,
        isLoading: !0
      }), de(D);
    }
  }, [r, e, d, a]), q.jsx("div", { id: d, className: Y["tfpa-head"], children: h.isLoading && g ? q.jsx(Ko, { children: q.jsx(Xo, { color: te }) }) : Uo(e) ? q.jsxs("div", { className: Y["tfpa-parent"], children: [q.jsx("img", { id: "orig", ref: x, src: e, alt: "image", className: N.transitionsType !== "drivewear" ? Y["tfpa-image1"] : Y["tfpa-image1-drivewear"], onLoad: B }), ee && q.jsx("div", { id: "logo", className: Y["tfpa-logo"], children: q.jsx("img", { id: "transitions-logo", style: { left: S.width - S.width * 0.2 }, className: Y["tfpa-transitions-logo"], width: S ? (S.width * 0.2).toFixed() + "px" : "40px", src: "https://tfpauatstawus001.blob.core.windows.net/fpa/transitions-logo-black.png" }) }), h.lensRemovalMask && !h.isFailed && !h.isLoading && (E || h.is_sunglass) && q.jsx("img", {
    id: "mask",
    style: { height: S.height, width: S.width, zIndex: 0 },
    src: h.lensRemovalMask,
    alt: "image2",
    className: N.transitionsType !== "drivewear" ? Y["tfpa-image2"] : Y["tfpa-image2-drivewear"],
    // onLoadStart={() => {
    //   if (!isShowLoading) {
    //     document.getElementById("fade")!.style.display = "none";
    //   }
    // }}
    onError: K
  }), h.maskLink && !h.isFailed && !h.isLoading && q.jsxs("div", { id: "fade", className: N.transitionsType ? Y[`tfpa-${N.transitionsType}`] : Y["tfpa-signature"], children: [q.jsx("img", { id: "mask", style: { height: S.height, width: S.width }, src: h.maskLink, alt: "image2", className: N.transitionsType !== "drivewear" ? Y["tfpa-image2"] : Y["tfpa-image2-drivewear"], onLoadStart: () => {
    g || (document.getElementById("fade").style.display = "none");
  }, onError: K }), N.transitionsType === "drivewear" && q.jsx("div", { className: Y["tfpa-drivewear"] })] }), q.jsx("div", { className: Y["tfpa-wbg"] })] }) : q.jsx("img", { id: "invalid", src: "https://tfpauatstawus001.blob.core.windows.net/fpa/logo-black.png", alt: "invalid", width: "100%" }) });
};
export {
  Zo as LIME
};
